export default status => {
  if (status === 'ACTIVE') {
    return '#ececff';
  } if (status === 'DEACTIVATED') {
    return '#ffe0b1';
  } if (status === 'EXPIRED') {
    return '#ee6972';
  } return '#e2e2e2';
};
